import {useEffect, useState} from 'react'
import {Space, Table, Button, Alert, Modal, Popconfirm, Tag} from 'antd'
import {DateComponent} from '../../../components/liste/dateComponent'
import {
  DeleteOutlined,
  DislikeOutlined,
  EditOutlined,
  LikeOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import {
  addProbabilite,
  deleteProbabilite,
  getListeProbabilite,
  updateEtatProbabilite,
  updateProbabilite,
} from '../../../data/params/probabilite'

const ProbabiliteDeSurvenance = () => {
  const [probabilites, setProbabilites] = useState([])
  const [probabilite, setProbabilite] = useState([])
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const [value, setValue] = useState('')
  const [libelle, setLibelle] = useState('')
  const [description, setDescription] = useState('')
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [edite, setEdite] = useState(false)

  const columns = [
    {
      title: '#',
      render: (text, record, index) => (
        <span className='display-block chart-blue'>{index + 1}</span>
      ),
    },
    {
      title: 'Valeur',
      dataIndex: 'value',
      key: 'value',
      render: (text) => <span className='display-block bold'>{text}</span>,
    },
    {
      title: 'Libelle',
      dataIndex: 'libelle',
      key: 'libelle',
      render: (text) => <span className='display-block bold'>{text}</span>,
    },
    {
      title: 'Etat',
      dataIndex: 'etat',
      key: 'etat',
      render: (_, record, index) =>
        record.etat === 1 ? <Tag color='green'>Activé</Tag> : <Tag color='red'>Désactivé</Tag>,
    },
    {
      title: 'Créée le / Par',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record, index) => (
        <DateComponent
          date={record.createdAt}
          user={record.nom_user + ' ' + record.prenom_user}
          key={index}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => selectProbabilite(record.id)}
          />

          {record.etat === 0 && (
            <Popconfirm
              title={`Activer la période ${record.libelle} ?`}
              description={`Voulez vous vraiment activer la période ${record.libelle} ?`}
              onConfirm={() => handleUpdateEtatProbabilite(record.id, 1)}
              okText='Oui'
              cancelText='Non'
            >
              <Button icon={<DislikeOutlined />} className='chart-bg-orange' title='Activer ?' />
            </Popconfirm>
          )}

          {record.etat === 1 && (
            <Popconfirm
              title={`Désactiver la période ${record.libelle} ?`}
              description={`Voulez vous vraiment désactiver la période ${record.libelle} ?`}
              onConfirm={() => handleUpdateEtatProbabilite(record.id, 0)}
              okText='Oui'
              cancelText='Non'
            >
              <Button icon={<LikeOutlined />} className='chart-bg-green' title='Désactiver ?' />
            </Popconfirm>
          )}

          <Popconfirm
            title={`Supprimer la période ${record.libelle} ?`}
            description={`Voulez vous vraiment supprimer la période ${record.libelle} ?`}
            onConfirm={() => handleDeleteProbabilite(record.id)}
            okText='Oui'
            cancelText='Non'
          >
            <Button title='Supprimer ?' type='primary' icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  const filteredItems = probabilites.filter(
    (item) =>
      item.libelle.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase()) ||
      item.id === parseInt(search)
  )

  const showModal = () => {
    setOpen(true)
  }

  const handleAddProbabilite = async () => {
    setLoading(true)
    const data = {value, libelle}
    console.log(data)
    const {status, message} = await addProbabilite(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setDescription('')
      setValue('')
      handleListeProbabilite()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleModifierProbabilite = async () => {
    setLoading(true)
    const data = {probabilite_id: probabilite.id, value, libelle}
    console.log(data)
    const {status, message} = await updateProbabilite(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setDescription('')
      setValue('')
      handleListeProbabilite()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleCancel = () => {
    setOpen(false)
    setEdite(false)
    setLibelle('')
    setDescription('')
    setValue('')
    setError(false)
  }

  const selectProbabilite = (probabilite_id) => {
    const privil = probabilites.filter((periode) => periode.id === probabilite_id)[0]
    setProbabilite(privil)
    setLibelle(privil.libelle)
    setDescription(privil.description)
    setValue(privil.value)
    setEdite(true)
    setOpen(true)
  }

  const handleListeProbabilite = async () => {
    setLoading(true)
    const {result, status, message} = await getListeProbabilite()
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setProbabilites(result)
      handleCancel()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleDeleteProbabilite = async (probabilite_id) => {
    setLoading(true)
    const data = {probabilite_id}
    const {status, message} = await deleteProbabilite(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      handleListeProbabilite()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleUpdateEtatProbabilite = async (probabilite_id, etat) => {
    setLoading(true)
    const data = {probabilite_id, etat}
    const {status, message} = await updateEtatProbabilite(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setDescription('')
      handleListeProbabilite()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  // const handleSearchDesCivilite = () => {
  //   const civs = probabilites.filter(civilite => civilite.id == )

  // }

  useEffect(() => {
    handleListeProbabilite()
  }, [])

  return (
    <>
      <div className='card mb-5 mb-lg-10'>
        {error === true && (
          <Space
            direction='vertical'
            style={{
              width: '100%',
            }}
          >
            <Alert message='Error' description={message} type='error' showIcon />
          </Space>
        )}

        <div className='card-header'>
          <div className='card-title'>
            <h3>Liste des probabilités de survenance</h3>
          </div>

          <div className='card-toolbar'>
            <div className='my-1 me-4'>
              <input
                type='text'
                name='fname'
                onChange={(e) => setSearch(e.target.value)}
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Rechercher'
              />
            </div>

            <Button type='primary' icon={<PlusOutlined />} onClick={showModal} size='large'>
              Ajouter
            </Button>
            {/* <a href="#" className="btn btn-sm btn-primary my-1">View All</a> */}
          </div>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredItems}
              pagination={{current: 1, pageSize: 50}}
            />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        title={!edite ? 'Enregistrer une nouvelle probabilite' : 'Modifier la probabilite'}
        onOk={!edite ? handleAddProbabilite : handleModifierProbabilite}
        onCancel={handleCancel}
        footer={[
          <Button key='back' onClick={handleCancel}>
            Annuler
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loading}
            onClick={!edite ? handleAddProbabilite : handleModifierProbabilite}
          >
            Enregistrer
          </Button>,
        ]}
      >
        {error === true && (
          <Space
            direction='vertical'
            style={{
              width: '100%',
            }}
          >
            <Alert message={message} type='error' showIcon />
          </Space>
        )}
        <p>
          <label className='bold'>Probabilite survenance</label>
          <select
            name='risque'
            className='form-select w-100 me-15'
            onChange={(e) => {
              setValue(parseInt(e.target.value))
            }}
            value={value}
          >
            <option value=''>Selectionner une valeur...</option>
            {['1', '2', '3', '4', '5'].map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </p>
        <p>
          <label className='bold'>Libelle</label>
          <input
            type='text'
            name='fname'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            onChange={(e) => setLibelle(e.target.value)}
            value={libelle}
            placeholder='Entrez le libelle'
          />
        </p>
      </Modal>
    </>
  )
}

export default ProbabiliteDeSurvenance
